import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { styled, useTheme } from "@mui/material/styles";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Stack,
  TextField,
} from "@mui/material";
import customStyles from "app/shared-components/SelectCustomStyle";
import Select from "react-select";
import { useState } from "react";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import moment from "moment";
import "../expense-claim/expenseClaim.css";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));

const DirectoryFilter = (props) => {
  const { handleSearch } = props;
  // const [companyName, setCompanyName] = useState("001");
  const [docNumber, setdocNumber] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [employeeCode, setEmployeeCode] = useState("");
  const [remarks, setRemarks] = useState("");
  const [approvalStatus, setApprovalStatus] = useState("");
  const approvalList = [
    { label: "ALL", value: "ALL" },
    { label: "FTP", value: "FTP" },
    { label: "FTFL", value: "FTFL" },
    { label: "PTC", value: "PTC" },
    { label: "PTH", value: "PTH" },
  ];

  return (
    <>
      <Box className="p-10" sx={{ flexGrow: 1 }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <div className="flex">
              <FormControl className="flex flex-row">
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className="my-0"
                  >
                    <Typography>Search Criteria</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Stack direction={"row"}>
                      <Stack className="mr-16">
                        Employee Code
                        <StyledTextField
                          type="text"
                          className="w-[120px]"
                          variant="outlined"
                          name="year"
                          value={employeeCode}
                          onChange={(e) => {
                            setEmployeeCode(e.target.value);
                          }}
                        />
                      </Stack>
                      <Stack className="mr-16">
                        Department
                        <Select
                          className="w-[200px]"
                          name="approval_status"
                          placeholder="Status"
                          options={approvalList}
                          styles={customStyles()}
                        />
                      </Stack>
                      <Stack className="mr-16">
                        Sub Department
                        <Select
                          className="w-[200px]"
                          name="approval_status"
                          placeholder="Status"
                          options={approvalList}
                          styles={customStyles()}
                        />
                      </Stack>
                      <Stack className="mr-16">
                        Designation
                        <Select
                          className="w-[200px]"
                          name="approval_status"
                          placeholder="Status"
                          options={approvalList}
                          styles={customStyles()}
                        />
                      </Stack>
                      <Stack className="mr-16">
                        Employee Name
                        <Select
                          className="w-[200px]"
                          name="approval_status"
                          placeholder="Status"
                          options={approvalList}
                          styles={customStyles()}
                        />
                      </Stack>
                    </Stack>
                    <Stack
                      direction={"row"}
                      style={{ alignItems: "end" }}
                      className="my-8"
                    >
                      <Stack className="mr-16">
                        Pay Group
                        <Select
                          className="w-[200px]"
                          name="approval_status"
                          placeholder="Status"
                          options={approvalList[0]}
                          styles={customStyles()}
                        />
                      </Stack>

                      <FormGroup
                        style={{ flexDirection: "row", margin: "0px 10px" }}
                      >
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Active"
                          className="mr-16"
                        />
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Non Active"
                          className="mr-16"
                        />
                      </FormGroup>

                      <Stack direction={"row"}>
                        <Button
                          color="warning"
                          variant="contained"
                          startIcon={
                            <FuseSvgIcon size={18}>
                              heroicons-outline:search
                            </FuseSvgIcon>
                          }
                          sx={{ mr: 1 }}
                        />

                        <Button
                          color="warning"
                          variant="contained"
                          onClick={() => {
                            setdocNumber("");
                            setFromDate("");
                            setToDate("");
                            setApprovalStatus("");
                            setEmployeeName("");
                            setRemarks("");
                          }}
                        >
                          Clear
                        </Button>
                      </Stack>
                    </Stack>
                  </AccordionDetails>
                </Accordion>
              </FormControl>
            </div>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default DirectoryFilter;
